export default function MoveToTour({ onComplete, onSkip }) {
    return (
      <div className="space-y-4">
        <h1 className="text-xl font-semibold text-center">You're all set!</h1>
        <p>
          We’ve saved your preferences. From here, you’ll get:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>Personalised recipes starting today</li>
          <li>Smart planning to avoid waste and simplify shopping</li>
          <li>Fast suggestions from whatever ingredients you have</li>
        </ul>
        <p>Let’s get you started with a quick tour.</p>
        <button
          onClick={onComplete}
          className="bg-sage w-full text-white px-4 py-2 rounded-3xl hover:bg-sagedark transition"
        >
          Start the tour
        </button>
        <button
          onClick={onSkip}
          className="border border-sage text-sage w-full px-4 py-2 rounded-3xl hover:bg-sage/20 transition"
        >
          Skip
        </button>
      </div>
    );
  }
  